import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './Landing.css';

const FREE_FEATURES = [
  { label: 'Sauvegarde sur le serveur local', included: true },
  { label: 'Sauvegarde FTP', included: true },
  { label: 'Sauvegarde SFTP', included: true },
  { label: 'Sauvegarde de la base de données', included: true },
  { label: 'Sauvegarde des fichiers du site', included: true },
  { label: 'Planification automatique (cron)', included: true },
  { label: 'Historique des sauvegardes', included: true },
  { label: 'Sauvegarde Google Drive', included: false },
  { label: 'Mises à jour automatiques', included: false },
  { label: 'Support 7j/7', included: false },
];

const PREMIUM_FEATURES = [
  { label: 'Tout ce qui est inclus dans la version gratuite', included: true },
  { label: 'Sauvegarde Google Drive', included: true },
  { label: 'Mises à jour automatiques', included: true },
  { label: 'Support par email 7j/7', included: true },
  { label: 'Priorité dans les tickets de support', included: true, annual: true },
  { label: 'Garantie satisfait ou remboursé 30j', included: true, annual: true },
];

const STEPS = [
  { num: '1', title: 'Créez un compte', desc: 'Inscription gratuite en 30 secondes. Pas de carte bancaire requise.' },
  { num: '2', title: 'Choisissez votre offre', desc: 'Mensuel à 50 €/mois ou annuel à 480 €/an. Sélectionnez votre domaine PrestaShop.' },
  { num: '3', title: 'Envoyez votre chèque', desc: 'Rédigez un chèque à l\'ordre de Technonet avec votre numéro de commande au dos.' },
  { num: '4', title: 'Recevez votre clé', desc: 'Une fois le chèque encaissé, votre clé de licence vous est transmise par email.' },
  { num: '5', title: 'Activez le module', desc: 'Collez votre clé dans les réglages du module et profitez des fonctionnalités premium.' },
];

const FAQS = [
  {
    q: 'Combien de temps après l\'envoi du chèque reçois-je ma licence ?',
    a: 'Comptez 3 à 5 jours ouvrés à réception du chèque. Nous vous envoyons votre clé de licence dès l\'encaissement.',
  },
  {
    q: 'Ma licence est valable pour combien de boutiques ?',
    a: 'Chaque licence est associée à un seul domaine PrestaShop. Pour plusieurs boutiques, commandez une licence par domaine.',
  },
  {
    q: 'Puis-je changer de formule mensuelle en annuelle ?',
    a: 'Oui, contactez-nous par email et nous proratiserons votre abonnement restant sur la formule annuelle.',
  },
  {
    q: 'Le module est-il compatible avec quelle version de PrestaShop ?',
    a: 'EvBackupManager est compatible avec PrestaShop 1.7.x et toutes les versions 8.x.',
  },
  {
    q: 'Que se passe-t-il si je ne renouvelle pas mon abonnement ?',
    a: 'Le module continue de fonctionner mais les fonctionnalités premium (Google Drive) sont désactivées. Vos données sont conservées.',
  },
];

export default function Landing() {
  return (
    <div className="landing">
      <Navbar />

      {/* ── Hero ── */}
      <section className="hero">
        <div className="container hero-inner">
          <div className="hero-content">
            <span className="hero-badge">Compatible PrestaShop 1.7 & 8.x</span>
            <h1 className="hero-title">
              Sauvegardez votre boutique<br />
              <span className="gradient-text">en toute sérénité</span>
            </h1>
            <p className="hero-subtitle">
              EvBackupManager est le module de sauvegarde professionnel pour PrestaShop.
              Planifiez vos sauvegardes en local, FTP, SFTP — ou sur Google Drive avec la version premium.
            </p>
            <div className="hero-actions">
              <a href="/api/modules/download" className="btn btn-primary btn-lg">
                ⬇️ Télécharger gratuitement
              </a>
              <a href="#pricing" className="btn btn-outline btn-lg">
                Voir les offres
              </a>
            </div>
            <p className="hero-note">Version gratuite disponible sans inscription · Pas de carte bancaire</p>
          </div>
          <div className="hero-visual">
            <div className="hero-card">
              <div className="hero-card-header">
                <span className="dot red" /><span className="dot yellow" /><span className="dot green" />
                <span className="hero-card-title">Dernière sauvegarde</span>
              </div>
              <div className="hero-card-body">
                <div className="backup-item success">
                  <span className="backup-icon">✅</span>
                  <div>
                    <div className="backup-name">backup_2026-04-14_02-00.zip</div>
                    <div className="backup-meta">Google Drive · 247 MB · Il y a 2h</div>
                  </div>
                </div>
                <div className="backup-item success">
                  <span className="backup-icon">✅</span>
                  <div>
                    <div className="backup-name">backup_2026-04-13_02-00.zip</div>
                    <div className="backup-meta">FTP Distant · 243 MB · Il y a 1j</div>
                  </div>
                </div>
                <div className="backup-item success">
                  <span className="backup-icon">✅</span>
                  <div>
                    <div className="backup-name">backup_2026-04-12_02-00.zip</div>
                    <div className="backup-meta">Serveur local · 241 MB · Il y a 2j</div>
                  </div>
                </div>
                <div className="backup-next">
                  <span>⏰</span> Prochaine sauvegarde dans <strong>22h</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Chiffres ── */}
      <section className="stats-bar">
        <div className="container stats-inner">
          <div className="stat"><strong>100%</strong><span>Open source (version gratuite)</span></div>
          <div className="stat"><strong>PS 1.7 & 8</strong><span>Compatible</span></div>
          <div className="stat"><strong>3 destinations</strong><span>Local, FTP/SFTP, Google Drive</span></div>
          <div className="stat"><strong>7j/7</strong><span>Support premium</span></div>
        </div>
      </section>

      {/* ── Features ── */}
      <section className="features section" id="features">
        <div className="container">
          <div className="section-header">
            <h2>Deux versions pour tous les besoins</h2>
            <p>Commencez gratuitement, passez premium quand vous en avez besoin</p>
          </div>

          <div className="features-grid">
            {/* Gratuit */}
            <div className="feature-plan">
              <div className="feature-plan-header">
                <h3>Version Gratuite</h3>
                <p>Pour les petites boutiques qui débutent</p>
              </div>
              <ul className="feature-list">
                {FREE_FEATURES.map((f, i) => (
                  <li key={i} className={f.included ? 'included' : 'excluded'}>
                    <span className="feature-icon">{f.included ? '✓' : '✗'}</span>
                    {f.label}
                  </li>
                ))}
              </ul>
              <a href="/api/modules/download" className="btn btn-outline btn-block mt-4">
                Télécharger gratuitement
              </a>
            </div>

            {/* Premium */}
            <div className="feature-plan feature-plan-premium">
              <div className="feature-plan-header">
                <span className="badge badge-accent">Premium</span>
                <h3>Version Premium</h3>
                <p>Pour les boutiques professionnelles</p>
              </div>
              <ul className="feature-list">
                {PREMIUM_FEATURES.map((f, i) => (
                  <li key={i} className={f.included ? 'included' : 'excluded'}>
                    <span className="feature-icon">✓</span>
                    {f.label}
                    {f.annual && <span className="annual-only">annuel seulement</span>}
                  </li>
                ))}
              </ul>
              <a href="#pricing" className="btn btn-accent btn-block mt-4">
                Voir les tarifs
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ── Pricing ── */}
      <section className="pricing section" id="pricing">
        <div className="container">
          <div className="section-header">
            <h2>Tarifs simples et transparents</h2>
            <p>Pas de frais cachés · Résiliable à tout moment</p>
          </div>

          <div className="pricing-grid">
            {/* Gratuit */}
            <div className="pricing-card">
              <div className="pricing-plan">Gratuit</div>
              <div className="pricing-price">
                <span className="price-amount">0 €</span>
                <span className="price-period">pour toujours</span>
              </div>
              <ul className="pricing-features">
                <li>✓ Sauvegarde locale</li>
                <li>✓ FTP &amp; SFTP</li>
                <li>✓ Planification automatique</li>
                <li>✗ Google Drive</li>
                <li>✗ Support dédié</li>
              </ul>
              <a href="/api/modules/download" className="btn btn-outline btn-block">
                Télécharger
              </a>
            </div>

            {/* Mensuel */}
            <div className="pricing-card">
              <div className="pricing-plan">Mensuel</div>
              <div className="pricing-price">
                <span className="price-amount">50 €</span>
                <span className="price-period">/ mois</span>
              </div>
              <ul className="pricing-features">
                <li>✓ Tout le gratuit</li>
                <li>✓ Google Drive</li>
                <li>✓ Mises à jour auto</li>
                <li>✓ Support 7j/7</li>
                <li>✗ Priorité support</li>
              </ul>
              <Link to="/register" className="btn btn-primary btn-block">
                Commencer
              </Link>
            </div>

            {/* Annuel */}
            <div className="pricing-card pricing-card-popular">
              <div className="popular-badge">⭐ Le plus populaire</div>
              <div className="pricing-plan">Annuel</div>
              <div className="pricing-price">
                <span className="price-amount">480 €</span>
                <span className="price-period">/ an</span>
              </div>
              <div className="pricing-saving">soit 40 €/mois · économisez 20 %</div>
              <ul className="pricing-features">
                <li>✓ Tout le mensuel</li>
                <li>✓ Priorité support</li>
                <li>✓ Garantie 30j remboursé</li>
                <li>✓ Accès aux beta</li>
                <li>✓ Tarif bloqué 1 an</li>
              </ul>
              <Link to="/register" className="btn btn-accent btn-block">
                Commencer — meilleur prix
              </Link>
            </div>
          </div>

          <p className="pricing-note">
            💳 Paiement uniquement par <strong>chèque</strong> pour le moment.
            D'autres moyens de paiement seront disponibles prochainement.
          </p>
        </div>
      </section>

      {/* ── How to order ── */}
      <section className="how-to-order section" id="how-to-order">
        <div className="container">
          <div className="section-header">
            <h2>Comment commander ?</h2>
            <p>Simple en 5 étapes, livraison par email</p>
          </div>

          <div className="steps">
            {STEPS.map(step => (
              <div key={step.num} className="step">
                <div className="step-num">{step.num}</div>
                <div className="step-content">
                  <h4>{step.title}</h4>
                  <p>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="cheque-info">
            <h3>📬 Adresse pour l'envoi du chèque</h3>
            <div className="cheque-box">
              <p><strong>À l'ordre de :</strong> Technonet</p>
              <p><strong>Adresse :</strong> À compléter — contactez-nous à contact@technonet.fr</p>
              <p><strong>Au dos du chèque :</strong> Indiquez votre adresse email et votre numéro de commande</p>
            </div>
          </div>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section className="faq section" id="faq">
        <div className="container">
          <div className="section-header">
            <h2>Questions fréquentes</h2>
          </div>
          <div className="faq-list">
            {FAQS.map((item, i) => (
              <details key={i} className="faq-item">
                <summary>{item.q}</summary>
                <p>{item.a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA final ── */}
      <section className="cta-section">
        <div className="container cta-inner">
          <h2>Protégez votre boutique dès aujourd'hui</h2>
          <p>Commencez gratuitement, sans engagement, sans carte bancaire.</p>
          <div className="cta-actions">
            <a href="/api/modules/download" className="btn btn-primary btn-lg">
              ⬇️ Télécharger gratuitement
            </a>
            <Link to="/register" className="btn btn-outline btn-lg" style={{ borderColor: 'rgba(255,255,255,.5)', color: 'var(--white)' }}>
              Créer un compte
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
